import { ReactElement } from 'react';
import { AddRounded, CheckCircleRounded } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styles
import styles from '../MultiTypeahead.module.scss';

// Types
import { ITypeaheadOption } from '../../Typeahead';

const StyledCheckCircleRounded = styled(CheckCircleRounded)({
  '.ja &': {
    color: '#00aea9',
  },
  border: 0,
  borderRadius: '50%',
  color: '#82bc00',
  height: '1.5rem',
  marginRight: '0.875rem',
  minWidth: '1.5rem',
  width: '1.5rem',
});

const StyledAddRounded = styled(AddRounded)({
  '.ja &': {
    color: '#00aea9',
  },
  color: '#82bc00',
  marginRight: '0.875rem',
  boxShadow: '1px 3px 8px 2px #00000019',
  border: 0,
  borderRadius: '50%',
});

interface IProps {
  option: ITypeaheadOption;
  selected: boolean;
}

export const InputOption = (props: IProps): ReactElement => {
  const { option, selected } = props;
  const { label } = option;

  return (
    <>
      {selected ? <StyledCheckCircleRounded /> : <StyledAddRounded />}
      <div className={styles['option-content']}>
        <div className={styles['option-content-label']}>{label}</div>
      </div>
    </>
  );
};
